import { BoxProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import React from 'react';
import { Box } from 'src/design/atoms/Box';
import classes from './FrozenPane.module.css';

export interface IFrozenPaneProps extends BoxProps, ElementProps<'div'> {
  frozen: boolean;
}

/** @registry Pins its children under the AppShell header (sticky, opaque, below Mantine overlays) while `frozen` is true; pair with useFrozenPane, which decides when the viewport can afford it. */
export const FrozenPane = React.forwardRef<HTMLDivElement, IFrozenPaneProps>(
  ({ frozen, className, ...others }, ref) => (
    <Box
      {...others}
      ref={ref}
      className={clsx(classes.root, className)}
      data-frozen={frozen || undefined}
    />
  ),
);
FrozenPane.displayName = 'FrozenPane';
